/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Suggestion_TitleInputs */

const en_us2_plan_suggestion_title = /** @type {(inputs: Plan_Suggestion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan is ready to move on`)
};

const pt_br2_plan_suggestion_title = /** @type {(inputs: Plan_Suggestion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu plano está pronto para avançar`)
};

const es_419_plan_suggestion_title = /** @type {(inputs: Plan_Suggestion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu plan está listo para avanzar`)
};

const pt_pt2_plan_suggestion_title = /** @type {(inputs: Plan_Suggestion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu plano está pronto para avançar`)
};

const fr_fr2_plan_suggestion_title = /** @type {(inputs: Plan_Suggestion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton programme est prêt à évoluer`)
};

const de_de2_plan_suggestion_title = /** @type {(inputs: Plan_Suggestion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Plan ist bereit für den nächsten Schritt`)
};

const it_it2_plan_suggestion_title = /** @type {(inputs: Plan_Suggestion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua scheda è pronta per il passo successivo`)
};

/**
* | output |
* | --- |
* | "Your plan is ready to move on" |
*
* @param {Plan_Suggestion_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_suggestion_title = /** @type {((inputs?: Plan_Suggestion_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Suggestion_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_suggestion_title(inputs)
	if (locale === "es-419") return es_419_plan_suggestion_title(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_suggestion_title(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_suggestion_title(inputs)
	if (locale === "de-DE") return de_de2_plan_suggestion_title(inputs)
	if (locale === "it-IT") return it_it2_plan_suggestion_title(inputs)
	return en_us2_plan_suggestion_title(inputs)
});
export { plan_suggestion_title as "plan.suggestion.title" }